export const CONFIG = {
  "PROJECTNAME": "bakour",
  "COMPANYNAME": "Bakour",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10199001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#1f3a7f",
    "primary100": "rgba(31,58,127,0.1)",
    "light": "#1f3a7f",
    "secondary": "#1f3a7f",
    "dark": "#1f3a7f",
    "siteColor3": "#fff",
    "menuSecondary": "#1f3a7f"
  }
};